import React, { useEffect } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import OrderContactQuestions2 from 'modules/order/components/contact-questions/contact-questions-2'
import useOrder from 'modules/order/state/order/use-order'
import { OrderContactAnswersSlice } from 'modules/order/state/contact-answers/contact-answers-types'
import { registerForm, unregisterForm } from '../../utils/single-step-form-orchestrator'
import styled from '@emotion/styled'

// Form data type for contact questions only
export type ContactQuestionsFormData = OrderContactAnswersSlice

const Container = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
`

interface ContactQuestionsFormProps {
  showRequired?: boolean
  showNameFields?: boolean
  useGridLayout?: boolean
}

const ContactQuestionsForm = ({
  showRequired = false,
  showNameFields = true,
  useGridLayout = true,
}: ContactQuestionsFormProps) => {
  const order = useOrder()

  // Initialize form with order data and validation
  const form = useForm<ContactQuestionsFormData>({
    values: {
      ...order.contactAnswers.value,
    },
    resolver: yupResolver(order.contactAnswers.schema),
    mode: 'onBlur',
    reValidateMode: 'onChange',
  })

  // Form name based on required/optional mode
  const formName = showRequired ? 'requiredContactQuestions' : 'optionalContactQuestions'

  // Register the form with the orchestrator
  useEffect(() => {
    registerForm({
      name: formName,
      formRef: form,
      errorMessage: `Please fill in all ${
        showRequired ? 'required' : 'optional'
      } contact question fields`,
    })

    return () => unregisterForm({ name: formName })
  }, [form, formName, showRequired])

  return (
    <FormProvider {...form}>
      <Container>
        {/* Contact Questions */}
        <OrderContactQuestions2
          showRequired={showRequired}
          showNameFields={showNameFields}
          useGridLayout={useGridLayout}
        />
      </Container>
    </FormProvider>
  )
}

export default ContactQuestionsForm
